// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/:params*\",\"regex\":\"^/(.+)$\",\"paramNames\":[\"params\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/403\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.4.3";import * as Sentry from "@sentry/nextjs";
import { baseConfig } from "./sentryConfig";

Sentry.init({ ...baseConfig, sendDefaultPii: true });
